import type { MachineOwnershipData } from '~/data/Asset';
import type { AssetListItem } from '~/data/AssetListItem/AssetListItem';
import BFFAPI from './utils/BFFAPI';

export interface AddMachineAPIType extends MachineOwnershipData {
  name: string;
  sensorId?: string;
  unmeasuredEngineHours: number;
  pncNumber?: string;
  serialNumber?: string | null;
}

export interface AddOtherBrandMachineAPIType extends MachineOwnershipData {
  name: string;
  pncNumber: string;
  brand: string;
  modelName: string;
  customBrandName: string;
  unmeasuredEngineHours: number;
}

export interface GetAssetListResponse {
  machines: AssetListItem[];
  totalNumberOfAssets: number;
}

class MachineAPI extends BFFAPI {
  getAssetListV3 = (filter: Record<string, string | string[]>): Promise<GetAssetListResponse> => {
    const req = this.fetchHelper.createGetRequest(`${this.endpoint}/v3`, filter);
    return this.fetch(req);
  };
  getAssetList = (filter: Record<string, string | string[]>): Promise<GetAssetListResponse> => {
    const req = this.fetchHelper.createGetRequest(
      `${process.env.ENDPOINT_BFF}/assets/list`,
      filter
    );
    return this.fetch(req);
  };

  getAssetListItemV2ById = (assetId: string): Promise<AssetListItem> => {
    const req = this.fetchHelper.createGetRequest(`${this.endpoint}/v2/listitem/${assetId}`);
    return this.fetch(req);
  };

  getAssetListItemById = (assetId: string): Promise<AssetListItem> => {
    const req = this.fetchHelper.createGetRequest(
      `${process.env.ENDPOINT_BFF}/assets/listitem/${assetId}`
    );
    return this.fetch(req);
  };

  registerMachine = (machine: AddMachineAPIType): Promise<AssetListItem> => {
    const req = this.fetchHelper.createPostRequest(`${this.endpoint}`, machine);
    return this.fetch(req);
  };

  registerOtherBrandMachine = (
    otherBrandMachine: AddOtherBrandMachineAPIType
  ): Promise<AssetListItem> => {
    const req = this.fetchHelper.createPostRequest(`${this.endpoint}`, otherBrandMachine);
    return this.fetch(req);
  };

  // Change name of machine
  changeMachineName = (machineId: string, machineName: string) => {
    const req = this.fetchHelper.createPostRequest(`${this.endpoint}/${machineId}/machine-name`, {
      machineName,
    });
    return this.fetch(req);
  };

  // Delete machine
  deleteMachine = (machineId: string) => {
    const req = this.fetchHelper.createDeleteRequest(
      `${this.endpoint}/${machineId}/relationship/companies`
    );
    return this.fetch(req);
  };

  batchDeactivateMachines = (assetIds: AssetId[]): any => {
    const req = this.fetchHelper.createPostRequest(`${this.endpoint}/deactivate`, assetIds);
    return this.fetch(req);
  };
  batchActivateMachines = (assetIds: AssetId[]): any => {
    const req = this.fetchHelper.createPostRequest(`${this.endpoint}/robotic/activate`, assetIds);
    return this.fetch(req);
  };
}

export default new MachineAPI('/fleet/secure/machines');
